/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "c1caa39f5f147c581de2815c1b4bd139020ab927";
